'use es6';

import { PHONE_NUMBERS_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes'; // This is the default Northam fallback sales number. NOT Invoca

const initialState = {
  'sales-footer': '1 857 829 5060',
  'sales-middle': '1 857 829 5060',
  'crm-middle': '1 857 829 5060',
  'marketing-footer': '1 857 829 5060',
  'marketing-middle': '1 857 829 5060',
  'service-footer': '1 857 829 5060',
  'service-middle': '1 857 829 5060',
  'crmsuite-middle': '1 857 829 5060',
  'crmsuite-footer': '1 857 829 5060',
  'cms-footer': '1 857 829 5060',
  'cms-middle': '1 857 829 5060',
  'operations-middle': '1 855 246 4707',
  'operations-footer': '1 833 553 1517',
  bundle: '1 857 829 5060'
};

const PhoneNumbers = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case PHONE_NUMBERS_RECEIVED:
      return payload.phoneNumbers;

    default:
      return state;
  }
};

export default PhoneNumbers;